import { Actions, StateChanges } from './stateChanges'
import { StoreConfig } from './storeConfig'
import axios from 'axios'

let morphApiUrl = StoreConfig.morphServerUrl
let nakdanApiUrl = StoreConfig.nakdanServerUrl
axios.defaults.headers = {
  'Content-Type': 'text/plain;charset=UTF-8'
  //'content-type': 'text/json'
}
const axiosInstance = axios.create({ timeout: 120000 })

export default {
  [Actions.RUN_TEXT_MORPH]: function ({ commit, state }) {
    commit(StateChanges.MORPH_RUNNING)
    const requestObj = {
      task: 'nakdan',
      apiKey: '3ab12a2f-80b3-450d-be66-8eb07748f9d2',
      data: state.textForApiCall,
      genre: state.textStyle,
      freturnfullmorphstr: true,
      addmorph: true,
      keepmetagim: true,
      keepnikud: true,
      keepqq: true,
      newjson: true
    }
    axiosInstance.post(nakdanApiUrl, JSON.stringify(requestObj))
      .then(function (response) {
        if (response.data) {
          commit(StateChanges.SET_RESULTS, response.data)
          commit(StateChanges.MORPH_COMPLETE)
        }
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.MORPH_TIMED_OUT)
        } else {
          commit(StateChanges.MORPH_FAILED)
        }
      })
  },

  [Actions.RUN_MORPH]: function ({ commit, state }) {
    commit(StateChanges.MORPH_RUNNING)
    const requestObj = {
      urls: state.urlList,
      email_recipient: state.userEmail,
      task: 'nakdan',
      genre: state.textStyle,
      freturnfullmorphstr: true,
      addmorph: true,
      keepmetagim: true,
      keepnikud: true,
      keepqq: true,
      newjson: true
    }
    axiosInstance.post(morphApiUrl + '/api', JSON.stringify(requestObj))
      .then(function (response) {
        if (response.data.taskID) {
          commit(StateChanges.SET_JOB_ID, response.data.taskID)
          commit(StateChanges.MORPH_COMPLETE)
          commit(StateChanges.SET_URL_LIST, [])
         
        }
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.MORPH_TIMED_OUT)
        } else {
          commit(StateChanges.MORPH_FAILED)
        }
      })
  },
  [Actions.CHECK_STATUS]: function ({ commit, state }) {
    commit(StateChanges.MORPH_RUNNING)
    let taskID = state.jobId
    axiosInstance.get(morphApiUrl + '/status/'+taskID)
      .then(function (response) {
        commit(StateChanges.SET_UPLOAD_STATUS, response.data)
        commit(StateChanges.MORPH_COMPLETE)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.MORPH_TIMED_OUT)
        } else {
          commit(StateChanges.MORPH_FAILED)
        }
      })
  }


}
